import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const atLeastOneFieldValidator = (group: UntypedFormGroup): ValidationErrors | null => {
  let isAtLeastOneFilled = false;

  Object.keys(group.controls).forEach((key) => {
    if (group.controls[key].value) {
      isAtLeastOneFilled = true;
    }
  });

  return isAtLeastOneFilled ? null : { atLeastOneRequired: true };
};
